<template>
  <auth-text>
    Bitte beachten Sie: Es gelten die
    <a :href="agbUrl" target="_blank">AGB</a> und
    <a :href="privacyUrl" target="_blank">Datenschutzbestimmungen</a>.
  </auth-text>
</template>

<script>
import AuthText from "@/components/plenigo-auth/components/auth-text";
export default {
  components: { AuthText },
  props: {
    agbUrl: String,
    privacyUrl: String
  }
};
</script>
